import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";
import cronstrue from "cronstrue";
import { isNumber } from "./MathHelpers";
dayjs.extend(tz);
dayjs.extend(utc);
dayjs.extend(tz);
export const DateOrdinal = function (d) {
    if (d > 3 && d < 21)
        return "th";
    switch (d % 10) {
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
};
export const mapIsoToLocal = (ele) => {
    if (ele === undefined || ele === "") {
        return "";
    }
    let date = ele;
    date = new Date(date);
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let dt = date.getDate();
    if (dt < 10) {
        dt = "0" + dt;
    }
    if (month < 10) {
        month = "0" + month;
    }
    date = month + "-" + dt + "-" + year;
    return date;
};
export function timeConverter(UNIX_timestamp, dateFormat, timeFormat) {
    let timeStampMilli = UNIX_timestamp.length === 10
        ? parseInt(UNIX_timestamp) * 1000
        : parseInt(UNIX_timestamp);
    let parsedDate = dayjs(timeStampMilli);
    return parsedDate.format(dateFormat + " " + timeFormat);
}
export function getDateXDaysAgo(numOfDays, date = new Date()) {
    const daysAgo = new Date(date.getTime());
    daysAgo.setDate(date.getDate() - numOfDays);
    daysAgo.setHours(0, 0, 0, 0);
    let result = daysAgo.toLocaleString("sv-SE").replace(",", "");
    return result;
}
export const getTimeZoneInHours2 = () => {
    const timezoneOffset = new Date().getTimezoneOffset();
    const offset = Math.abs(timezoneOffset);
    const offsetOperator = timezoneOffset < 0 ? "+" : "-";
    const offsetHours = Math.floor(offset / 60)
        .toString()
        .padStart(2, "0");
    const offsetMinutes = Math.floor(offset % 60)
        .toString()
        .padStart(2, "0");
    return `${offsetOperator}${offsetHours}:${offsetMinutes}`;
};
export const getTimeZoneInHours = () => {
    const timezoneOffset = new Date().getTimezoneOffset();
    const offset = Math.abs(timezoneOffset);
    //%2B - '+', because these are sent in query params in API URL
    const offsetOperator = timezoneOffset < 0 ? "%2B" : "-";
    const offsetHours = Math.floor(offset / 60)
        .toString()
        .padStart(2, "0");
    const offsetMinutes = Math.floor(offset % 60)
        .toString()
        .padStart(2, "0");
    return `${offsetOperator}${offsetHours}:${offsetMinutes}`;
};
export function getTimeZoneInISTFixed(timestamp) {
    if (!timestamp)
        return "";
    try {
        const [date, timeWithMs] = timestamp.replace("Z", "").split("T");
        const time = timeWithMs.split(".")[0]; // drop existing ms
        return `${date}T${time}.000+05:30`;
    }
    catch (e) {
        console.error("Invalid timestamp:", timestamp);
        return timestamp;
    }
}
export function getTimezoneName(date) {
    const today = new Date(date);
    const short = today.toLocaleDateString(undefined);
    const full = today.toLocaleDateString(undefined, { timeZoneName: "long" });
    // Trying to remove date from the string in a locale-agnostic way
    const shortIndex = full.indexOf(short);
    if (shortIndex >= 0) {
        const trimmed = full.substring(0, shortIndex) + full.substring(shortIndex + short.length);
        // by this time `trimmed` should be the timezone's name with some punctuation -
        // trim it from both sides
        return trimmed.replace(/^[\s,.\-:;]+|[\s,.\-:;]+$/g, "");
    }
    else {
        // in some magic case when short representation of date is not present in the long one, just return the long one as a fallback, since it should contain the timezone's name
        return full;
    }
}
export const getMonthsBetweenDates = (startDate, endDate) => {
    startDate = new Date(startDate).setDate(1);
    let endD = new Date(endDate).setDate(1);
    const months = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endD) {
        let monthNum = currentDate.toLocaleString("default", {
            month: "numeric",
        });
        const monthYearString = `${currentDate.getFullYear()}/${monthNum < 10 ? "0" : ""}${monthNum}`;
        months.push(monthYearString);
        // Move to the next month
        currentDate.setMonth(currentDate.getMonth() + 1);
    }
    return months;
};
export const isNumberValidBetweenDates = (startDate, endDate, number) => {
    if (number < 1 || number > 31) {
        return false;
    }
    const startDt = new Date(new Date(startDate).setHours(0, 0, 0, 0)), endDt = new Date(new Date(endDate).setHours(0, 0, 0, 0));
    if (startDt == "Invalid Date" || endDt == "Invalid Date") {
        return false;
    }
    const months = getMonthsBetweenDates(startDt, endDt);
    let isValid = false;
    for (let i = 0; i < months.length; i++) {
        const possibleDate = new Date(`${months[i]}/${number}`);
        possibleDate.setHours(0, 0, 0, 0);
        isValid =
            possibleDate != "Invalid Date" &&
                dayjs(`${months[i]}/${number < 10 ? "0" : ""}${number}`, "YYYY/MM/DD").format("YYYY/MM/DD") ===
                    `${months[i]}/${number < 10 ? "0" : ""}${number}` &&
                possibleDate >= startDt &&
                possibleDate <= endDt;
        if (isValid)
            break;
    }
    return isValid;
};
export const getAllWeekDayNamesBetweenDates = (startDate, endDate) => {
    const weekdays = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    const result = [];
    startDate = new Date(startDate.setHours(0, 0, 0, 0));
    endDate = new Date(endDate.setHours(0, 0, 0, 0));
    while (startDate <= endDate) {
        const currentDay = weekdays[startDate.getDay()];
        if (!result.includes(currentDay))
            result.push(currentDay);
        // Move to the next day
        startDate.setDate(startDate.getDate() + 1);
    }
    return result;
};
export const customDateStart = (startDateForAPI) => {
    if (dayjs(startDateForAPI).format("YYYY-MM-DD") == "Invalid Date") {
        return startDateForAPI;
    }
    else {
        return (dayjs(startDateForAPI).format("YYYY-MM-DD") +
            `T00:00:00.000` +
            getTimeZoneInHours());
    }
};
export const customDateEnd = (endDateForAPI) => {
    if (dayjs(endDateForAPI).format("YYYY-MM-DD") == "Invalid Date") {
        return endDateForAPI;
    }
    else {
        return endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))
            ? dayjs(new Date()).format("YYYY-MM-DD") +
                `T${dayjs().format("YYYY-MM-DD HH:mm:ss").split(" ")[1]}.000` +
                getTimeZoneInHours()
            : dayjs(endDateForAPI).subtract(1, "day").format("YYYY-MM-DD") +
                `T23:59:59.000` +
                getTimeZoneInHours();
    }
};
export const customDateEndReportsWA = (endDate) => {
    if (endDate.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        return (dayjs(new Date()).format("YYYY-MM-DD") +
            `T${dayjs().format("YYYY-MM-DD HH:mm:ss").split(" ")[1]}.000` +
            getTimeZoneInHours());
    }
    else {
        return endDate;
    }
};
export const customDateStartUTCTimeZone = (startDateForAPI) => {
    let startDate = startDateForAPI.split("T")[0] + " 00:00:00";
    startDate = dayjs(startDate).utc().format("YYYY-MM-DD HH:mm:ss");
    return startDate;
};
export const customDateEndUTCTimeZone = (endDateForAPI) => {
    if (endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        let endDate = endDateForAPI.split("T")[0] + " " + dayjs().format("HH:mm:ss");
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        return endDate;
    }
    else {
        let endDate = endDateForAPI.split("T")[0] + " 23:59:59";
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        return endDate;
    }
};
export const customDateStartUTCTimeZoneZ = (startDateForAPI) => {
    if (dayjs(startDateForAPI).format("YYYY-MM-DD") == "Invalid Date") {
        return startDateForAPI;
    }
    let startDate = startDateForAPI.split("T")[0] + " 00:00:00";
    startDate = dayjs(startDate).utc().format("YYYY-MM-DD HH:mm:ss");
    startDate = startDate.split(" ").join("T") + ".000Z";
    return startDate;
};
export const customDateFormatStartAndEnd = (date, zone) => {
    if (dayjs(date).format("YYYY-MM-DD") == "Invalid Date") {
        return date;
    }
    let finalDate = date.split("T")[0] + (zone == "0" ? " 00:00:00" : " 23:59:59");
    finalDate = dayjs(finalDate).format("YYYY-MM-DD HH:mm:ss");
    finalDate =
        finalDate.split(" ").join("T") + (zone == "0" ? ".000Z" : ".999Z");
    return finalDate;
};
export const customDateStartUTCTimeZoneZDetails = (startDateForAPI) => {
    let startDate = startDateForAPI.split("T")[0] + " 00:00:00";
    startDate = dayjs(startDate).utc().format("YYYY-MM-DD HH:mm:ss");
    startDate = startDate.split(" ").join("T") + ".000Z";
    return startDate;
};
export const customDateEndUTCTimeZoneZ = (endDateForAPI) => {
    if (dayjs(endDateForAPI).format("YYYY-MM-DD") == "Invalid Date") {
        return endDateForAPI;
    }
    if (endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        let endDate = endDateForAPI.split("T")[0] + " " + dayjs().format("HH:mm:ss");
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.split(" ").join("T") + ".999Z";
        return endDate;
    }
    else {
        let endDate = endDateForAPI.split("T")[0] + " 23:59:59";
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.split(" ").join("T") + ".999Z";
        return endDate;
    }
};
export const customDateEndUTCTimeZoneZDetails = (endDateForAPI) => {
    if (endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        let endDate = endDateForAPI.split("T")[0] + " " + dayjs().format("HH:mm:ss");
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.split(" ").join("T") + ".999Z";
        return endDate;
    }
    else {
        let endDate = endDateForAPI.split("T")[0] + " 23:59:59";
        endDate = dayjs(endDate).utc().format("YYYY-MM-DD HH:mm:ss");
        endDate = endDate.split(" ").join("T") + ".999Z";
        return endDate;
    }
};
export const getLocalFormattedDate = (date, dateFormat = "YYYY-MM-DD", timeFormat = "HH:mm:ss") => {
    if (new Date(date) == "Invalid Date") {
        return date;
    }
    else {
        return dayjs(date)
            .utc("z")
            .local()
            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .format(`${dateFormat} ${timeFormat}`);
    }
};
export const getLocalFormattedDate24Hr = (date, dateFormat = "YYYY-MM-DD", timeFormat = "HH:mm:ss") => {
    if (new Date(date) == "Invalid Date") {
        return date;
    }
    else {
        return dayjs(date)
            .utc("z")
            .local()
            .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
            .format(`${dateFormat} ${timeFormat}`);
    }
};
export const customDateStartWithoutTz = (startDateForAPI) => {
    let startDate = startDateForAPI.split("T")[0] + " 00:00:00";
    startDate = dayjs(startDate).format("YYYY-MM-DD HH:mm:ss");
    return startDate;
};
export const customDateEndWitoutTz = (endDateForAPI) => {
    if (endDateForAPI.includes(dayjs(new Date()).format("YYYY-MM-DD"))) {
        let endDate = endDateForAPI.split("T")[0] + " " + dayjs().format("HH:mm:ss");
        endDate = dayjs(endDate).format("YYYY-MM-DD HH:mm:ss");
        return endDate;
    }
    else {
        let endDate = endDateForAPI.split("T")[0] + " 23:59:59";
        endDate = dayjs(endDate).format("YYYY-MM-DD HH:mm:ss");
        return endDate;
    }
};
export const getFormattedMonthForInvoice = (month) => {
    if (!month)
        return "";
    try {
        return dayjs(new Date(month)).format("YYYY-MM");
    }
    catch (e) {
        return month;
    }
};
export function convertISOToCustomFormat(dates) {
    const { sDate, eDate } = dates;
    const isValidDate = (date) => dayjs(date).isValid();
    const formattedDates = {
        sDate: isValidDate(sDate)
            ? `${dayjs(sDate).format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
            : "",
        eDate: isValidDate(eDate)
            ? `${dayjs(eDate)
                .subtract(1, "day")
                .format("YYYY-MM-DD")} ${dayjs().format("HH:mm:ss")}`
            : "",
    };
    return formattedDates;
}
export const formatTime = (timestamp) => {
    return timestamp && !isNaN(timestamp)
        ? dayjs(new Date(parseInt(timestamp))).format("YYYY-MM-DD hh:mm:ss A")
        : "NA";
};
const normalizeQuartzCron = (expr) => {
    let parts = expr.trim().split(/\s+/);
    while (parts.length < 6) {
        parts.unshift("0"); // add prefix "0"
    }
    return parts.join(" ");
};
// function cronToLocalTimeString(exp, timeFormat) {
//   // First get the standard description
//   let expr = normalizeQuartzCron(exp);
//   let description = cronstrue.toString(expr, {
//     verbose: true,
//     use24HourTimeFormat: true,
//   });
//   // Find all time patterns (HH:MM) in the description
//   const timeRegex = /(\d{1,2}):(\d{2})(?::(\d{2}))?/g;
//   let match;
//   const originalStr = description;
//   while ((match = timeRegex.exec(originalStr)) !== null) {
//     const [utcTime, hours, minutes, seconds] = match;
//     // Create a Day.js object in UTC
//     const utcDate = dayjs
//       .utc()
//       .hour(isNumber(hours) ? parseInt(hours) : 0)
//       .minute(isNumber(minutes) ? parseInt(minutes) : 0)
//       .second(isNumber(seconds) ? parseInt(seconds) : 0)
//       .millisecond(0);
//     // Convert to local time
//     const localTime = utcDate.local().format(timeFormat);
//     // Replace in description
//     description = description.replace(utcTime, localTime);
//   }
//   return description;
// }
// export const parseCron = (exp, timeFormat) => {
//   try {
//     // test expresssions
//     // exp = "00 37 15 14 08 ? 2025,00 37 15 15 08 ? 2025,00 37 15 16 08 ? 2025";
//     // exp = "0 4 7 7,8 * ?,0 3 6 7,8 * ?";
//     // @todo: remove comma separator from api response & provide a unique character as separator as comma is valid in quartz cron expression
//     let exps = exp.split(",");
//     let parsed = [];
//     let cronExpres = "";
//     for (let i = 0; i < exps.length; i++) {
//       cronExpres += exps[i];
//       if (cronExpres.split(" ").length < 6) {
//         cronExpres += ",";
//         continue;
//       }
//       parsed.push(cronToLocalTimeString(cronExpres, timeFormat));
//       cronExpres = "";
//     }
//     return parsed.join("\n\n");
//   } catch (err) {
//     console.error("error while parsing cron exp: ", exp, err);
//     return "-";
//   }
// };
function cronToLocalTimeString(exp, timeFormat) {
    let expr = normalizeQuartzCron(exp);
    let description = cronstrue.toString(expr, {
        verbose: true,
        use24HourTimeFormat: true,
    });
    // Replace each HH:mm(:ss) in description with local time
    description = description.replace(/(\d{1,2}):(\d{2})(?::(\d{2}))?/g, (_, h, m, s) => {
        const utcDate = dayjs
            .utc()
            .hour(isNumber(h) ? parseInt(h) : 0)
            .minute(isNumber(m) ? parseInt(m) : 0)
            .second(isNumber(s) ? parseInt(s) : 0)
            .millisecond(0);
        return utcDate.local().format(timeFormat);
    });
    return description;
}
export const parseCron = (exp, timeFormat = "HH:mm:ss") => {
    try {
        let exps = exp.split(",");
        let parsed = [];
        let cronExpres = "";
        for (let i = 0; i < exps.length; i++) {
            cronExpres += exps[i];
            if (cronExpres.split(" ").length < 6) {
                cronExpres += ",";
                continue;
            }
            parsed.push(cronToLocalTimeString(cronExpres, timeFormat));
            cronExpres = "";
        }
        return parsed.join("\n\n");
    }
    catch (err) {
        console.error("error while parsing cron exp: ", exp, err);
        return "-";
    }
};
